import {SvgIconData} from '@shared_web/components/core/svg_icon';

import {TEXT_MAIN_COLOR} from '@mavismart_frontend/lib/constants';

export const icon_arrow_left_circle: SvgIconData = {
  viewBox: '0 0 24 24',
  element: (
    <path
      d="M10.8333 15.5L7.33333 12M7.33333 12L10.8333 8.5M7.33333 12L16.6667 12M1.5 12C1.5 6.20101 6.20101 1.5 12 1.5C17.799 1.5 22.5 6.20101 22.5 12C22.5 17.799 17.799 22.5 12 22.5C6.20101 22.5 1.5 17.799 1.5 12Z"
      stroke={TEXT_MAIN_COLOR}
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  ),
};
